export const IMAGE_WEBP_MIME = 'image/webp';
export const IMAGE_WEBP_EXT = 'webp';
export const DEFAULT_WEBP_QUALITY = 0.8;

export type CropAreaPixels = { x: number; y: number; width: number; height: number };

export const readFileAsDataURL = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

const createHtmlImage = (src: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', () => reject(new Error('이미지 로드 실패')));
    image.src = src;
  });

const canvasToWebpBlob = (canvas: HTMLCanvasElement, quality = DEFAULT_WEBP_QUALITY): Promise<Blob> =>
  new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error('WebP 변환 실패'))),
      IMAGE_WEBP_MIME,
      quality
    );
  });

/** 크롭 후 정사각형 outputSize로 리사이즈하여 WebP Blob 반환 */
export const cropSquareToWebp = async (
  imageSrc: string,
  cropPixels: CropAreaPixels,
  outputSize: number,
  quality = DEFAULT_WEBP_QUALITY
): Promise<Blob> => {
  return cropRectToWebp(imageSrc, cropPixels, outputSize, outputSize, quality);
};

/** 크롭 후 지정 가로·세로로 리사이즈하여 WebP Blob 반환 */
export const cropRectToWebp = async (
  imageSrc: string,
  cropPixels: CropAreaPixels,
  outputWidth: number,
  outputHeight: number,
  quality = DEFAULT_WEBP_QUALITY
): Promise<Blob> => {
  const image = await createHtmlImage(imageSrc);
  const cropCanvas = document.createElement('canvas');
  cropCanvas.width = Math.max(1, Math.floor(cropPixels.width));
  cropCanvas.height = Math.max(1, Math.floor(cropPixels.height));
  const cropCtx = cropCanvas.getContext('2d');
  if (!cropCtx) throw new Error('canvas context 생성 실패');
  cropCtx.drawImage(
    image,
    cropPixels.x,
    cropPixels.y,
    cropPixels.width,
    cropPixels.height,
    0,
    0,
    cropCanvas.width,
    cropCanvas.height
  );

  const outCanvas = document.createElement('canvas');
  outCanvas.width = Math.max(1, Math.floor(outputWidth));
  outCanvas.height = Math.max(1, Math.floor(outputHeight));
  const outCtx = outCanvas.getContext('2d');
  if (!outCtx) throw new Error('canvas context 생성 실패');
  outCtx.imageSmoothingEnabled = true;
  outCtx.imageSmoothingQuality = 'high';
  outCtx.drawImage(cropCanvas, 0, 0, outCanvas.width, outCanvas.height);
  return canvasToWebpBlob(outCanvas, quality);
};
